const ScenarioType = {
    DTScenario: 'DTScenario',
    FAQScenario: 'FAQScenario',
    SwitchScenario: 'SwitchScenario'
}

export default ScenarioType


// WEBPACK FOOTER //
// ./src/enums/scenario-type.js